import { Column } from "components/Table/Simple";

export const columns: Column[] = [
    {
        label: "ID",
        field: "id",
    },
    {
        label: "시술명",
        field: "name",
        creatable: true,
        editable: true,
    },
    {
        label: "진료과목",
        field: "specialties",
        render: (value, field, row) => {
            return row.specialties.map((specialty: any) => specialty.name).join(", ");
        }
    },
    {
        label: "고민",
        field: "concerns",
        render: (value, field, row) => {
            return row.concerns.map((concern: any) => concern.name).join(", ");
        }
    },
    {
        label: "시술부위",
        field: "parts",
        render: (value, field, row) => {
            return row.parts.map((part: any) => part.name).join(", ");
        }
    },
    {
        label: "설명",
        field: "description",
        creatable: true,
        editable: true,
    },
];